import { Alert, Button, Input, message, Pagination, Popconfirm } from 'antd';
import { CheckOutlined, DeleteOutlined, StarOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';
import CrmTextModal from '../../../components/Modal/CrmTextModal';
import React from 'react';
import { QUERY_PROJECTS } from '../../../graphql/project';
import cls from './ModalSelectProject.module.scss';
import _ from 'lodash';
import cn from 'classnames';
import { isDark } from '../../../helpers/color';
import ImageUrl from '../../../helpers/ImageUrl';

export function ModalSelectProject({ client, type, onUpdate, edit = false, current }) {
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const [search, setSearch] = React.useState('');

    const query = useQuery(QUERY_PROJECTS, {
        variables: {
            filters: {
                name: {containsi: search}
            },
            pagination: {
                pageSize: 20,
                page: page,
            }
        },
        onError: (error) => {
            message.error(error.message);
        }
    });

    const [update, updateData] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);

    const onSelectProject = async (id) => {
        await update({
            variables: {
                id: client.id,
                data: {
                    project: id,
                    projectData: null,
                }
            },
            onCompleted: () => {
                setOpen(false);
                onUpdate()
            }
        });
    }

    return (
        <>
            <CrmTextModal isOpen={open} onClose={() => setOpen(false)} title={'Назначить проект'}>
                <div className={cls.grid}>
                    <Alert type={'warning'} message={'Изменение проекта'} description={'При изменении проекта у клиента пропадут данные уровней и навыков текущего проекта'}/>
                    <Input.Search allowClear placeholder={'Поиск по названию...'} onSearch={(value) => setSearch(value)} />
                    {_.map(query.data?.projects?.data, (project) => (
                        <div
                            key={project.id}
                            className={cls.item}
                            style={{
                                backgroundColor: project.attributes.color,
                                backgroundImage: `url(${ImageUrl(project.attributes.cover?.data?.attributes?.url)})`,
                            }}
                        >
                            <div className={cn(cls.name, isDark(project.attributes.color || '#F0F0F0') && cls.white)}>
                                {project.attributes.name}
                            </div>
                            <div className={cls.logo}>
                                {project.attributes.logo?.data && (
                                    <img
                                        src={ImageUrl(project.attributes.logo?.data?.attributes?.url)}
                                        alt={project.attributes.name}
                                    />
                                )}
                            </div>
                            <div>
                                {edit ? (
                                    <Popconfirm
                                        title={'Изменить проект'}
                                        description={'Вы уверены что хотите изменить проект?'}
                                        onConfirm={() => onSelectProject(project.id)}
                                        okText={'Да'}
                                        cancelText={'Нет'}
                                        overlayStyle={{zIndex: 99999999}}
                                    >
                                        <Button type={current === project.id ? 'primary' : 'default'} icon={<CheckOutlined />}/>
                                    </Popconfirm>
                                ) : (
                                    <Button
                                        onClick={() => onSelectProject(project.id)}
                                        icon={<CheckOutlined />}
                                    >
                                        Назначить
                                    </Button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <Pagination
                    className={'crm-task-pagination'}
                    defaultCurrent={page}
                    current={page}
                    total={query.data?.projects?.meta?.pagination?.total}
                    pageSize={20}
                    onChange={(page) => {
                        setPage(page);
                    }}
                />
            </CrmTextModal>
            <Button
                loading={updateData.loading}
                type={'link'}
                icon={<StarOutlined />}
                onClick={() => {
                    setOpen(true);
                }}
            >
                {edit ? 'Выбрать другой проект' : 'Выбрать'}
            </Button>
        </>
    );
}
